package com.xtream.ui.tv.presentation.series

import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.wrapContentHeight
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.itemsIndexed
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.BookmarkAdded
import androidx.compose.material.icons.outlined.BookmarkAdd
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.saveable.rememberSaveable
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.focus.FocusRequester
import androidx.compose.ui.focus.focusRequester
import androidx.compose.ui.focus.focusRestorer
import androidx.compose.ui.unit.dp
import androidx.lifecycle.compose.collectAsStateWithLifecycle
import coil3.compose.rememberAsyncImagePainter
import com.xtream.composeapp.LocalAppViewModelStoreOwner
import com.xtream.composeapp.LocalSnackbarHostState
import com.xtream.composeapp.data.Screen
import com.xtream.composeapp.presentation.ui.navigation.RootNavViewModel
import com.xtream.sharedResources.resources.Res
import com.xtream.sharedResources.resources.add_to_favorites
import com.xtream.sharedResources.resources.remove_from_favorites
import com.xtream.sharedResources.resources.season
import com.xtream.composeapp.viewmodel.SeriesInfoViewModel
import com.xtream.composeapp.viewmodel.SeriesViewModel
import com.xtream.composeapp.viewmodel.UserViewModel
import com.xtream.data_kmp.AllConst
import com.xtream.data_kmp.XtreamUtils
import com.xtream.data_kmp.dto.SeriesInfo
import com.xtream.data_kmp.dto.SeriesStream
import com.xtream.data_kmp.dto.VodStream
import com.xtream.data_kmp.util.extension.formatTime
import com.xtream.ui.tv.presentation.common.LazyContentRow
import com.xtream.ui.tv.presentation.common.TvBaseInfoLayout
import com.xtream.ui.tv.presentation.common.TvInfoComposeLayout
import com.xtream.ui.tv.presentation.common.rememberRowFocusState
import com.xtream.ui.ui.widget.NetworkImageCard
import kotlinx.coroutines.launch
import org.jetbrains.compose.resources.stringResource
import org.koin.compose.viewmodel.koinViewModel
import org.koin.core.parameter.parametersOf


@Composable
fun TvShowTvInfoComposeScreen(
    id: Int?,
    onNavigationIconClick: () -> Unit = {},
    onMainButtonClick: (url: String?, title: String?, backdropPath: String?, infos: List<String>?, progress: Long, episodes:List<VodStream>, episodeId:Int) -> Unit = { _, _, _, _, _, _, _-> },
    userInfViewModel: UserViewModel = koinViewModel(),
    onRelatedItemClick: (SeriesStream?) -> Unit = {},
    navKey: Screen.TvShowDetail
) {
   val  vodInfoViewModel: SeriesInfoViewModel = koinViewModel( parameters = { parametersOf(navKey.id) })

    val tvShowStreamsViewModel: SeriesViewModel = koinViewModel( key="seriesStream_${navKey::class.simpleName}${navKey.hashCode()}")/*hiltViewModel<SeriesViewModel, SeriesViewModel.Factory>(
        creationCallback = { factory ->
            factory.create(navKey)
        }
    )*/
    val viewModelStoreOwner =LocalAppViewModelStoreOwner.current// activity as ViewModelStoreOwner

         val rootNavViewModel: RootNavViewModel = koinViewModel(
        viewModelStoreOwner= viewModelStoreOwner
    )

        val tvShowInfoState by vodInfoViewModel.selectedSeriesViewModel.collectAsState()
        val scope = rememberCoroutineScope()
        // Fetch stream asynchronously
    val streamState by vodInfoViewModel.streamState.collectAsStateWithLifecycle()
        val isFavorite by remember(streamState) { tvShowStreamsViewModel.isFavoriteFlow(streamState) }.collectAsStateWithLifecycle(false)
        var items by remember { mutableStateOf<List<SeriesStream>>(emptyList()) }

        val showNavigationIcon=
            remember {
                rootNavViewModel.backStack.size > 1
            }
    var trailerUrl by rememberSaveable(id) { mutableStateOf<String?>(null) }



    @OptIn(ExperimentalMaterial3Api::class)
         TvBaseInfoLayout(
        backDropPainter =  rememberAsyncImagePainter( tvShowInfoState?.info?.backdrop_path?.firstOrNull()),

        backLayerContent = {
            val snackbarHostState = LocalSnackbarHostState.current

            TvInfoComposeLayout(
                modifier = Modifier.padding(horizontal = 48.dp).fillMaxSize(),
                title = tvShowInfoState?.info?.name,
                rating = tvShowInfoState?.info?.formattedRating(),
                plot = tvShowInfoState?.info?.plot,
                releaseDate = tvShowInfoState?.info?.releaseDate,
                duration = tvShowInfoState?.info?.duration?.formatTime(),
                secondaryButtonTitle = stringResource( if(isFavorite) Res.string.remove_from_favorites else Res.string.add_to_favorites),
                secondaryButtonIcon = if(isFavorite) Icons.Filled.BookmarkAdded else  Icons.Outlined.BookmarkAdd,
                onSecondaryButtonClick = {
                    tvShowStreamsViewModel.updateFavoriteStatus(streamState)
                },
                tertiaryButtonEnabled = !trailerUrl.isNullOrBlank(),
                tertiaryButtonClick = {
                     snackbarHostState.currentSnackbarData?.dismiss()
                    TODO()
/*
                    activity.openYoutubeTrailer( trailerUrl?:"", onError = {err->
                        scope.launch( Dispatchers.Main) {
                            snackbarHostState.showSnackbar(
                                message = err.message.toString(),

                                )
                        }
                    })*/
                  //  rootNavViewModel.navigate( Screen.Trailer(trailerUrl))
                },


                )
        },
        frontLayerContent = {

                    EpisodesComposeTv(tvShowInfoState=tvShowInfoState,
                        onEpisodeClick = onMainButtonClick,
                        parentId=streamState?.streamId)










        }

        )



    LaunchedEffect(tvShowInfoState) {
        trailerUrl = tvShowInfoState?.info?.youtubeTrailer
    }


    /*val updatedId by rememberUpdatedState(id)

    LaunchedEffect(updatedId) {
        if(streamState ==null) {
            Log.d("MovieInfoMob", "LaunchedEffect: $id")
            val stream = id?.let { tvShowStreamsViewModel.getTvShowByStreamId(it) }

            // Load stream info
            stream?.streamId?.let { streamId ->
                vodInfoViewModel.loadInfo(streamId) {
                    // optional callback logic
                    trailerUrl = it?.info?.youtubeTrailer
                }
            }

        }

        // Collect favorite state

    }*/


}

@Composable
fun EpisodesComposeTv(
    tvShowInfoState: SeriesInfo?, parentId:Int?,
    seriesStreamsViewModel : SeriesViewModel? = null,
    onEpisodeClick: (url: String?, title: String?, backdropPath: String?, infos: List<String>?, progress: Long, episodes:List<VodStream>,episodeId:Int) -> Unit = {_, _, _, _,_, _, _-> },



    ){
    val userInfViewModel: UserViewModel = koinViewModel()


    val columnFocusRequester = remember { FocusRequester() }
    val defaultRowFocusRequester = remember { FocusRequester() }
    val scope = rememberCoroutineScope()


    LazyColumn(
        modifier = Modifier.focusRequester(columnFocusRequester).focusRestorer(defaultRowFocusRequester),
        contentPadding = PaddingValues(horizontal = 24.dp, vertical =48.dp),
    )
    {


        itemsIndexed(tvShowInfoState?.episodes?.toList() ?: emptyList())
        {index,(season,episodes)->

            val list = episodes.map {
                VodStream(
                    streamId = it.streamId,
                    name = it.name,
                    streamIcon = tvShowInfoState?.info?.backdrop_path?.getOrNull(0),
                    categoryId = parentId ?: -1,
                    containerExtension = it.containerExtension ?: "",
                    directSource = it.directSource

                )
            }
            val defaultRowItemFR = remember { FocusRequester() }

            val focusState = rememberRowFocusState()




            LazyContentRow(
                focusRequester = defaultRowFocusRequester,
                focusRestorer = focusState.currentRestorer,
                modifier =  Modifier .wrapContentHeight()
                    .fillMaxWidth(),//.wrapContentHeight(),
                title =stringResource(Res.string.season).plus(": ").plus(season) /*stringResource(R.string.episodes)*/,
                actionTitle = null, onActionClick = { }) {
                itemsIndexed(list) { itemIndex, stream ->
                    val itemModifier = if (itemIndex == 0)
                        Modifier.focusRequester(defaultRowItemFR)
                    else
                        Modifier
                    NetworkImageCard(
                        modifier = itemModifier,
                        src = stream.streamIcon,
                        title = stream.name ?: "",
                        //description = stream?..formattedRating()?: "",
                        onClick = {
                          //  columnFocusRequester.saveFocusedChild()
                           // defaultRowFocusRequester.saveFocusedChild()
                            scope.launch {
                                val user = userInfViewModel.loggedInUser()

                                val url = XtreamUtils.buildStreamUrl(
                                    user,
                                    stream,
                                    streamType = AllConst.SERIES_STREAMS,
                                    format = "." +
                                            stream.containerExtension
                                )
                                val progress =
                                    seriesStreamsViewModel?.getWatchedStream(stream.streamId)?.progress

                                onEpisodeClick.invoke(
                                    url, stream.name, stream.streamIcon,
                                    listOf<String>(
                                        tvShowInfoState?.info?.genre ?: "",
                                        tvShowInfoState?.info?.releaseDate ?: ""
                                    ), progress ?: 0L, list, stream.streamId
                                )
                            }

                        }
                    )
                }


            }

        }








    }

}